import React from 'react';
import { Logo } from './Logo';
export function Header() {
  return <header className="relative z-10" data-id="element-58" data-mp="1laoff7e2s5ra">
      <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-4 sm:px-8" data-id="element-59" data-mp="2dnflcenvf2qn">
        <a href="#top" aria-label="Pawsy Emprende — inicio" data-id="element-60" data-mp="2il7mlzaeo17i">
          <Logo size="sm" data-id="element-61" data-mp="2ints7tdqk6n3" />
        </a>
      </div>
    </header>;
}